import ModelService from './model.service';

const FontService = new ModelService('/fonts', '/fonts', 'animations');

FontService.getImage = (filename, w = false, h = false, c = false) => FontService.getFilePathByDir('/uploads/fonts', filename, w, h, c);

FontService.STATUS_INACTIVE = 0;
FontService.STATUS_ACTIVE = 1;

FontService.getStatusList = t => ({
  [FontService.STATUS_INACTIVE]: t('Inactive'),
  [FontService.STATUS_ACTIVE]: t('Active'),
});

FontService.getStatusOptions = t => FontService
  .prepareOptionsFromSimpleObject(FontService.getStatusList(t));

FontService.getColorByStatus = (status) => {
  switch (status) {
    case FontService.STATUS_INACTIVE:
      return 'danger';
    case FontService.STATUS_ACTIVE:
      return 'success';
    default:
      return 'secondary';
  }
};

FontService.getStatusTitle = (status, t) => {
  const label = FontService.getStatusList(t)[status];
  return label || '-';
};

export default FontService;



// WEBPACK FOOTER //
// ./src/services/font.service.js